export default __webpack_public_path__ + "static/media/graphics.f51fca25.png";